/** Manual "urgent" flag next to the client name (§6.3) — purely operator-set, never derived. */
export function HotToggle({ active, onToggle }: { active: boolean; onToggle: () => void }) {
  return (
    <button
      type="button"
      className={`hot-toggle ${active ? "active" : ""}`}
      title={active ? "Прибрати позначку «гаряче»" : "Позначити як гаряче"}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
    >
      🔥
    </button>
  );
}
